<ng-container>
  <div class="cg-page-blue-top blue-bar-extended">
    <div class="cg-inner-page-wrapper">
      <h1 class="cg-h1">
        Welcome<ng-container *ngIf="firstName$ | async"
          >, {{ firstName$ | async }}</ng-container
        >
      </h1>
      <cigna-new-features-banner
        [features]="newFeatureBanners$ | async"
        [isLoading]="latestUpdatesLoading$ | async"
      ></cigna-new-features-banner>
    </div>
  </div>
  <section class="cg-inner-page-wrapper blue-bar-content-overlap">
    <div class="flex-row">
      <div
        class="col-xs-12 col-sm-12 col-md-8 col-lg-8"
        *ngIf="
          (hasPatientSearch$ | async) ||
          (hasClaimSearch$ | async) ||
          (hasDelegation$ | async)
        "
      >
        <div
          *ngIf="hasPatientSearch$ | async"
          class="tile-container white-tile-bg"
        >
          <cigna-patients-tile
            [isEditable]="(impersonator$ | async) === false"
            [isRestrictedImpersonator]="restrictedImpersonator$ | async"
            [appContext]="appContext"
          ></cigna-patients-tile>
        </div>

        <div
          *ngIf="hasClaimSearch$ | async"
          class="tile-container white-tile-bg"
        >
          <cigna-claims-tile
            [isEditable]="(impersonator$ | async) === false"
            [isRestrictedImpersonator]="restrictedImpersonator$ | async"
            [appContext]="appContext"
          ></cigna-claims-tile>
        </div>
        <div
          *ngIf="hasDelegation$ | async"
          class="tile-container white-tile-bg"
        >
          <cigna-manage-access-tile
            [appContext]="appContext"
            [hasPagination]="manageAccessTilePagination$ | async"
          ></cigna-manage-access-tile>
        </div>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <div
          class="tile-container white-tile-bg"
          *ngIf="messageCenterFeatureFlag$ | async"
        >
          <cigna-message-center-widget
            [messages]="messages$ | async"
            [isImpersonator]="impersonator$ | async"
            (fetchMessages)="dashboardFacade.fetchMessages($event)"
          ></cigna-message-center-widget>
        </div>

        <div class="tile-container white-tile-bg">
          <cigna-latest-updates-tile
            [features]="newFeatures$ | async"
            [updates]="latestUpdates$ | async"
            [isLoading]="latestUpdatesLoading$ | async"
            [shouldShowNewFeatures]="true"
            [appContext]="appContext"
          ></cigna-latest-updates-tile>
        </div>
      </div>
    </div>
  </section>
</ng-container>
